export enum NavigationTabs {
  HOME = 'home',
  AUDIO = 'audio',
  CODE = 'code',
  LOCATION = 'location',
  FAVORITES = 'favorites',
  NONE = 'none'
}
